export class PackagingSystemPaginationFields {
  public static readonly Id = 'Id';
  public static readonly DirectoryId = 'DirectoryId';
  public static readonly BrandName = 'BrandName';
  public static readonly ProductName = 'ProductName';
  public static readonly ArticleNumber = 'ArticleNumber';
  public static readonly Tag = 'Tag';
  public static readonly Supplier = 'Supplier';
  public static readonly Gtin = 'GTIN';
  public static readonly AssemblyLocation = 'AssemblyLocation';
  public static readonly DistributionLocations = 'DistributionLocations';
  public static readonly Length = 'Length';
  public static readonly Width = 'Width';
  public static readonly Height = 'Height';
  public static readonly CreationTimestamp = 'CreationTimestamp';
  public static readonly LastModificationTimestamp = 'LastModificationTimestamp';
  public static readonly HasPPWRDocuments = 'HasPPWRDocuments';
  public static readonly HasImages = 'HasImages';
  public static readonly HasCertificates = 'HasCertificates';
  public static readonly HasAdditionalDocuments = 'HasAdditionalDocuments';
}
export class PackagingUnitPaginationFields {
  public static readonly Id = 'Id';
  public static readonly DirectoryId = 'DirectoryId';
  public static readonly BrandName = 'BrandName';
  public static readonly ProductName = 'ProductName';
  public static readonly ArticleNumber = 'ArticleNumber';
  public static readonly Tag = 'Tag';
  public static readonly PackagingType = 'PackagingType';
  public static readonly Supplier = 'Supplier';
  public static readonly Gtin = 'GTIN';
  public static readonly FillingGoodType = 'FillingGood';
  public static readonly FillingGoodCategory = 'Category';
  public static readonly FillingGood = 'ProductCategory';
  public static readonly PackagingQuantity = 'Quantity';
  public static readonly PackagingVolume = 'Volume';
  public static readonly DistributionLocations = 'DistributionLocations';
  public static readonly AssemblyLocation = 'AssemblyLocation';
  public static readonly Length = 'Length';
  public static readonly Width = 'Width';
  public static readonly Height = 'Height';
  public static readonly CreationTimestamp = 'CreationTimestamp';
  public static readonly LastModificationTimestamp = 'LastModificationTimestamp';
  public static readonly HasPPWRDocuments = 'HasPPWRDocuments';
  public static readonly HasImages = 'HasImages';
  public static readonly HasCertificates = 'HasCertificates';
  public static readonly HasAdditionalDocuments = 'HasAdditionalDocuments';
  public static readonly PackagingLevel = 'PackagingLevel';
  public static readonly IsPackagingPartOfProduct = 'IsPackagingPartOfProduct';
  public static readonly IsMultiUsePackaging = 'IsMultiUsePackaging';
}

export class PackagingComponentPaginationFields {
  public static readonly Id = 'Id';
  public static readonly DirectoryId = 'DirectoryId';
  public static readonly ArticleName = 'ArticleName';
  public static readonly ArticleNumber = 'ArticleNumber';
  public static readonly Tag = 'Tag';
  public static readonly Manufacturer = 'Manufacturer';
  public static readonly PackagingComponentCategory = 'PackagingComponentCategory';
  public static readonly PackagingComponentSubtype = 'PackagingComponentSubtype';
  public static readonly Gtin = 'GTIN';
  public static readonly ManufacturingLocation = 'ManufacturingLocation';
  public static readonly DistributionLocations = 'DistributionLocations';
  public static readonly Length = 'Length';
  public static readonly Width = 'Width';
  public static readonly Height = 'Height';
  public static readonly CreationTimestamp = 'CreationTimestamp';
  public static readonly LastModificationTimestamp = 'LastModificationTimestamp';
  public static readonly HasImages = 'HasImages';
  public static readonly HasCertificates = 'HasCertificates';
  public static readonly HasAdditionalDocuments = 'HasAdditionalDocuments';
  public static readonly PrintingCoverage = 'PrintingCoverage';
  public static readonly HasDirectContactWithProduct = 'HasDirectContactWithProduct';
  public static readonly IsRigidComponent = 'isRigid';
  public static readonly ContainsNearInfraredBarrier = 'NirBarrier';
}

export class MultiMaterialPaginationFields {
  public static readonly Id = 'Id';
  public static readonly DirectoryId = 'DirectoryId';
  public static readonly ArticleName = 'ArticleName';
  public static readonly ArticleNumber = 'ArticleNumber';
  public static readonly Tag = 'Tag';
  public static readonly ManufacturerName = 'ManufacturerName';
  public static readonly Gtin = 'GTIN';
  public static readonly ManufacturingLocation = 'ManufacturingLocation';
  public static readonly CreationTimestamp = 'CreationTimestamp';
  public static readonly LastModificationTimestamp = 'LastModificationTimestamp';
  public static readonly HasImages = 'HasImages';
  public static readonly HasCertificates = 'HasCertificates';
  public static readonly HasAdditionalDocuments = 'HasAdditionalDocuments';
  public static readonly TotalWeight = 'TotalMass';
  public static readonly TotalGrammage = 'TotalGrammage';
}

export class DataExchangeRequestPaginationFields {
  public static readonly Id = 'Id';
  public static readonly Name = 'Name';
  public static readonly Sender = 'Sender';
  public static readonly Recipient = 'Receiver';
  public static readonly Items = 'Items';
  public static readonly CreatedAt = 'CreationTimestamp';
  public static readonly Status = 'Status';
  public static readonly Deadline = 'Deadline';
  public static readonly DeadlineState = 'DeadlineState';
  public static readonly SubmissionState = 'SubmissionState';
  public static readonly ClosingState = 'ClosingState';
  public static readonly HasPendingReopen = 'HasPendingReopen';
}

export class DataExchangeSubRequestPaginationFields {
  public static readonly DataExchangeRequestId = 'DataExchangeRequestId';
  public static readonly Id = 'Id';
  public static readonly ArticleName = 'ArticleName';
  public static readonly ArticleNumber = 'ArticleNumber';
  public static readonly Manufacturer = 'Manufacturer';
  public static readonly Status = 'Status';
  public static readonly LastModificationTimestamp = 'LastModificationTimestamp';
  public static readonly PackagingComponentType = 'PackagingComponentType';
  public static readonly PackagingType = 'PackagingType';
  public static readonly BrandName = 'BrandName';
  public static readonly ProductName = 'ProductName';
  public static readonly HasPendingReopen = 'HasPendingReopen';
}

export class ExportInfoPaginationFields {
  public static readonly ExportTimestamp = 'ExportTimestamp';
  public static readonly OrganizationId = 'OrganizationId';
  public static readonly ImportCandidateId = 'ImportCandidateId';
  public static readonly Status = 'Status';
  public static readonly Tracking = 'Tracking';
  public static readonly Id = 'Id';
  public static readonly Version = 'Version';
  public static readonly ExportProfile = 'ExportProfile';
  public static readonly ProductName = 'ProductName';
  public static readonly BrandName = 'BrandName';
  public static readonly ArticleNumber = 'ArticleNumber';
  public static readonly ArticleName = 'ArticleName';
}

export class ImportCandidatePaginationFields {
  public static readonly ExportTimestamp = 'ExportTimestamp';
  public static readonly OrganizationId = 'OrganizationId';
  public static readonly ImportCandidateId = 'ImportCandidateId';
  public static readonly IsImported = 'IsImported';
  public static readonly HasNotification = 'HasNotification';
  public static readonly Trackable = 'Trackable';
  public static readonly Id = 'Id';
  public static readonly Version = 'Version';
  public static readonly ProductName = 'ProductName';
  public static readonly BrandName = 'BrandName';
  public static readonly ArticleNumber = 'ArticleNumber';
  public static readonly ArticleName = 'ArticleName';
  public static readonly PackagingType = 'PackagingType';
  public static readonly ComponentCategory = 'ComponentCategory';
  public static readonly ComponentSubtype = 'ComponentSubtype';
}

export class ChangePaginationFields {
  public static readonly Id = 'Id';
  public static readonly UpdatedId = 'UpdatedId';
  public static readonly ImportCandidateId = 'ImportCandidateId';
  public static readonly OrganizationId = 'OrganizationId';
  public static readonly HasNotification = 'HasNotification';
  public static readonly ChangeTimestamp = 'ChangeTimestamp';
  public static readonly ProductName = 'ProductName';
  public static readonly UpdatedProductName = 'UpdatedProductName';
  public static readonly BrandName = 'BrandName';
  public static readonly UpdatedBrandName = 'UpdatedBrandName';
  public static readonly ArticleNumber = 'ArticleNumber';
  public static readonly UpdatedArticleNumber = 'UpdatedArticleNumber';
  public static readonly ArticleName = 'ArticleName';
  public static readonly UpdatedArticleName = 'UpdatedArticleName';
  public static readonly Version = 'Version';
  public static readonly UpdatedVersion = 'UpdatedVersion';
  public static readonly PackagingType = 'PackagingType';
  public static readonly UpdatedPackagingType = 'UpdatedPackagingType';
  public static readonly ComponentCategory = 'ComponentCategory';
  public static readonly UpdatedComponentCategory = 'UpdatedComponentCategory';
  public static readonly ComponentSubtype = 'ComponentSubtype';
  public static readonly UpdatedComponentSubtype = 'UpdatedComponentSubtype';
}

export class PpwrPaginationFields {
  public static readonly Id = 'Id';
  public static readonly DirectoryId = 'DirectoryId';
  public static readonly BrandName = 'BrandName';
  public static readonly ProductName = 'ProductName';
  public static readonly ArticleNumber = 'ArticleNumber';
  public static readonly Supplier = 'Supplier';
  public static readonly IsCompliant = 'IsCompliant';
  public static readonly IsApproved = 'IsApproved';
  public static readonly DataExchangeRequestStatus = 'DataExchangeRequestStatus';
  public static readonly DataExchangeRequestDeadline = 'DataExchangeRequestDeadline';
  public static readonly DataExchangeRequestDeadlineState = 'DataExchangeRequestDeadlineState';
  public static readonly DataExchangeRequestSubmissionState = 'DataExchangeRequestSubmissionState';
  public static readonly DataExchangeRequestClosingState = 'DataExchangeRequestClosingState';
  public static readonly IsDocGenerated = 'IsDocGenerated';
  public static readonly TechnicalDocumentationStatus = 'TechnicalDocumentationStatus';
  public static readonly NewestVersionWithDoc = 'NewestVersionWithDoc';
  public static readonly NewestVersionWithTD = 'NewestVersionWithTD';
}
